import { render, staticRenderFns } from "./LogsOperData.vue?vue&type=template&id=4fd283da&"
import script from "./LogsOperData.vue?vue&type=script&lang=js&"
export * from "./LogsOperData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports